import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["name", "value", "options", "orientation", "onChange", "onBlur"];
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source), true)).call(_context3, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context4; _forEachInstanceProperty(_context4 = ownKeys(Object(source))).call(_context4, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable react/jsx-no-bind */
import React, { useCallback } from 'react';
import Box from '@rexlabs/box';
import { useToken } from '@rexlabs/styling';
import { RadioButton } from './';
import { noop } from 'lodash';
var displayName = 'RadioGroupInput';
/**
 * Radio buttons allow users to select a single option from a list of mutually exclusive options. All possible options are exposed up front for users to compare.
 */

function RadioGroupInput(_ref) {
  var name = _ref.name,
      value = _ref.value,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      _ref$orientation = _ref.orientation,
      orientation = _ref$orientation === void 0 ? 'vertical' : _ref$orientation,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? noop : _ref$onChange,
      _ref$onBlur = _ref.onBlur,
      onBlur = _ref$onBlur === void 0 ? noop : _ref$onBlur,
      inputProps = _objectWithoutProperties(_ref, _excluded);

  var token = useToken();
  var handleChange = useCallback(function (e, value) {
    var event = _objectSpread(_objectSpread({}, e), {}, {
      target: _objectSpread(_objectSpread({}, e.target), {}, {
        value: value,
        type: 'radio'
      })
    });

    onChange(event);
    onBlur(event);
  }, [onChange, onBlur]);
  var direction = orientation === 'vertical' ? 'column' : 'row';
  return /*#__PURE__*/React.createElement(Box, {
    sx: token('radio.group.spacing', token('spacing.m')),
    flexDirection: direction
  }, _mapInstanceProperty(options).call(options, function (option) {
    var _context, _context2;

    return /*#__PURE__*/React.createElement(RadioButton, _extends({}, inputProps, option === null || option === void 0 ? void 0 : option.props, {
      key: option.value,
      id: _concatInstanceProperty(_context = "".concat(name, ".")).call(_context, option.value),
      name: _concatInstanceProperty(_context2 = "".concat(name, ".")).call(_context2, option.value),
      label: option.label,
      value: option.value.toString() === (value === null || value === void 0 ? void 0 : value.toString()),
      onChange: function onChange(e) {
        return handleChange(e, option.value);
      }
    }));
  }));
}

RadioGroupInput.displayName = displayName;
export default RadioGroupInput;